import React, { Component } from 'react';
import { connect } from 'react-redux';
import config from '../../config';
import uuid from 'uuid';
import store from 'store2';
import getDecodedToken from '../../common/auth/utils/getDecodedToken';
import { getStripeExpressLoginLink } from './redux/actions';

class StripeExpress extends Component {
  state = {
    csrfToken: uuid(),
  };

  signupForStripeExpress = () => {
    store.set('stripe_state', this.state.csrfToken);
  };

  goToStripeExpressDashboard = () => {
    let stripeExpressWindow = window.open();

    this.props.dispatch(getStripeExpressLoginLink(getDecodedToken().sub)).then(response => {
      stripeExpressWindow.opener = null;
      stripeExpressWindow.location = response.json.url;
    });
  };

  render() {
    const { profile } = this.props;
    const { csrfToken } = this.state;

    return profile.get('stripe_express_account_id') ? (
      <button className="button button--theme--outline" type="button" onClick={this.goToStripeExpressDashboard}>
        Go to your Stripe Express Dashboard
      </button>
    ) : (
      <a
        className="button button--theme--outline"
        href={`https://connect.stripe.com/express/oauth/authorize?redirect_uri=${config.auth
          .redirectUri}/subscription/ms-admin/connect&client_id=${config.stripe.connectClientId}&state=${csrfToken}`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={this.signupForStripeExpress}
      >
        Go to Stripe Express
      </a>
    );
  }
}

const mapStateToProps = state => {
  return {
    profile: state.subscription.user.getIn(['data', 'movementSpecialistProfile']),
  };
};
export default connect(mapStateToProps)(StripeExpress);



// WEBPACK FOOTER //
// ./src/subscription/movement-specialist-admin/StripeExpress.js